<script lang="ts">
	import { Button, Modal, Label, Input, Checkbox, A } from 'flowbite-svelte';

	import logoImg from '$lib/assets/images/logo.svg';
	import axios from 'axios';
	import { authModal, restoreModal } from '$lib/stores';
	import { goto } from '$app/navigation';
	import PasswordInput from '../ui/PasswordInput/PasswordInput.svelte';

	export let show = false;
	export let onClose: any = () => ({});

	let error: any;
	let identifier: any;
	let password: any;
	let rememberMe: boolean = true;

	async function login(e: Event) {
		try {
			const { data } = await axios.post('/api/login', { identifier, password, rememberMe });

			if (data.err) {
				error = true;
				return;
			}

			// если авторизация успешна - полностью ребутим страницу - чтобы сессии/куки обновились
			window.location = '/profile';
		} catch (err: any) {
			error = true;
		}
	}

	const getToRegister = () => {
		authModal.set(false);
		goto('/profile/register');
	};
	const goToRestore = () => {
		authModal.set(false);
		restoreModal.set(true);
	};
</script>

<Modal
	bind:open={show}
	size="xs"
	on:close={onClose}
	autoclose={false}
	outsideclose
	defaultClass="relative flex flex-col mx-auto rounded-[20px] pt-3 pb-5"
>
	<form class="flex flex-col space-y-6" action="#" data-testid="modalwindow-login-form">
		<h3 class="mb-4 text-xl font-medium text-center text-gray-900 dark:text-white">Авторизация</h3>
		{#if error}
			<h4>
				<div data-testid="modalwindow-login-form-error-invalid-username-or-password">
					Неверные имя или пароль
				</div>
			</h4>
		{/if}
		<Label class="space-y-2">
			<span>Логин</span>
			<Input
				type="text"
				name="identifier"
				bind:value={identifier}
				placeholder="Введите электронную почту"
				data-testid="modalwindow-login-form-input-email"
				required
			/>
		</Label>
		<Label class="space-y-2">
			<span>Пароль</span>
			<PasswordInput
				name="password"
				bind:value={password}
				placeholder="Введите пароль"
				data-testid="modalwindow-login-form-input-password"
				required
			/>
		</Label>
		<div class="flex justify-start">
			<Checkbox bind:checked={rememberMe}>Запомнить меня</Checkbox>
		</div>
		<Button
			on:click={login}
			class="w-full bg-blue-400 hover:bg-blue-700 focus:ring-blue-300"
			data-testid="modalwindow-login-form-button-entry"
		>
			Войти
		</Button>
		<div class="flex justify-between text-sm">
			<A on:click={goToRestore} class="text-gray-500 hover:underline">Забыли пароль?</A>
			<A class="text-blue-400 hover:underline" on:click={getToRegister}>Регистрация</A>
		</div>
		<div class="text-center">
			<img src={logoImg} class="max-w-[178px] inline-block object-cover" alt="" />
		</div>
	</form>
</Modal>
